
import { Component, Vue, Watch } from 'vue-property-decorator';
import VueGridLayout from 'vue-grid-layout';
import WorkList from './components/index.vue';
import { getRepairWorkbench } from '@/api/workBench';
import { UserModule } from '@/store/modules/user';
import { returnLayout, returnPamars } from '@/utils/workBenchUtil';
import { WorkbenchLayoutModule } from '@/store/modules/workBench';

@Component({
  name: 'Worktable',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    WorkList
  }
})

export default class extends Vue {
  private layoutData: any = ''

  private layout: any = []

  private isDraggable = false
  private settingHandle() {
    this.$router.push({
      path: '/indexEdit',
      query: {}
    });
  }
  private pamarsLoc:any={
    order_information_type: 1,
    unfinish_order_information_size: 10,

    branch_company_type: 1,
    branch_company_size: 6,

    service_company_statistics_type: 1,
    service_company_statistics_size: 8,

    untreated_check_order_information_size: 3,

    order_bbs_information_size: 5
  }

  created() {
    this.layout = [];
    if (WorkbenchLayoutModule.getLayout && WorkbenchLayoutModule.getLayout.length > 0) {
      this.layout = WorkbenchLayoutModule.getLayout;
    } else {
      this.layout = returnLayout();
    }
    let pamars = {
      ...this.pamarsLoc,
      ...returnPamars(this.layout)
    };
    this.getRepairWorkbench(pamars);
  }
  private fullscreen() {
    let element: any = document.getElementById('fullGridId');
    if (element) {
      let requestMethod = element.requestFullscreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
      if (requestMethod) {
        requestMethod.call(element);
      } else if (typeof window.ActiveXObject !== 'undefined') {
        var wscript = new ActiveXObject('WScript.Shell');
        if (wscript !== null) {
          wscript.SendKeys('{F11}');
        }
      }
    }
  }

  private getRepairWorkbench(ps:any) {
    let pamars:any = {
      ...ps
    };
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    getRepairWorkbench(pamars).then((res:any) => {
      if (res.data) {
        this.layoutData = res.data;
      }
    });
  }
  private allPamarsClick(val:any) {
    let pamars = { ...this.pamarsLoc, ...val };
    this.getRepairWorkbench(pamars);
  }

  private deleteMenuHandle(val: any) {
    const index = this.layout.map((item: any) => item.i).indexOf(val.i);
    this.layout.splice(index, 1);
  }
  private addMenuHandle(val: any) {
    if (val.w === 8 || val.w === 12) {
      this.$set(val, 'x', 0);
      this.$set(val, 'y', 0);
    } else {
      this.layout.forEach((ele: any) => {
        if ((ele.w + ele.x > 8) && ele.y === 0) {
          this.$set(ele, 'y', val.h);
        } else {
          this.$set(ele, 'y', val.h + ele.y);
        }
      });
      this.$set(val, 'x', 8);
      this.$set(val, 'y', 0);
    }
    this.layout.unshift(val);
  }
}

